import script from "./TableBase.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableBase.vue?vue&type=script&setup=true&lang=ts"

import "./TableBase.vue?vue&type=style&index=0&id=da5e7932&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da5e7932"]])

export default __exports__